import { useRef, useCallback } from 'react';
import { useWorkspaceStore } from '../../panels/use-workspace-store';
import {
    ActionHandler,
    useIntegratedActionBroadcaster,
} from '../../action-broadcaster/use-integrated-action-broadcaster';
import { useApplicationType } from '../../common/hooks/use-application-type';

export const useUpdateToEventKeyboardHandler = () => {
    const showEntitiesPopoverRef = useRef<() => void>();
    const { activeWorkspaceWindowType } = useWorkspaceStore();
    const { isFirstResponder } = useApplicationType();

    if (
        activeWorkspaceWindowType !== 'EVENT_V2' &&
        activeWorkspaceWindowType !== 'QUEUE_V2' &&
        !(isFirstResponder && activeWorkspaceWindowType == undefined)
    ) {
        throw new Error('Found unexpected active workspace window type');
    }

    const handleActions: ActionHandler<'EVENT_V2' | 'QUEUE_V2' | 'ROOT'> = useCallback((action) => {
        switch (action.type) {
            case 'DEX_RESULTS_PANEL_UPDATE_TO_EVENT': {
                showEntitiesPopoverRef.current?.();
                return true;
            }
        }
    }, []);

    useIntegratedActionBroadcaster({
        id: 'DEX_RESULTS_PANEL_UPDATE_TO_EVENT',
        windowType: activeWorkspaceWindowType ?? 'ROOT',
        handler: handleActions,
    });

    return { showEntitiesPopoverRef };
};
